import { render, staticRenderFns } from "./file-history.vue?vue&type=template&id=6a6d8b91&scoped=true"
import script from "./file-history.vue?vue&type=script&lang=js"
export * from "./file-history.vue?vue&type=script&lang=js"
import style0 from "./file-history.vue?vue&type=style&index=0&id=6a6d8b91&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d8b91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6d8b91')) {
      api.createRecord('6a6d8b91', component.options)
    } else {
      api.reload('6a6d8b91', component.options)
    }
    module.hot.accept("./file-history.vue?vue&type=template&id=6a6d8b91&scoped=true", function () {
      api.rerender('6a6d8b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/file-history.vue"
export default component.exports